module.exports = __webpack_public_path__ + "static/media/Sms_Icon.095b01a5.svg";